


















































import { Component, Vue } from 'vue-property-decorator'

import Images from '@/data/images'
import 'semantic-ui-css/components/image.min.css'
import 'semantic-ui-css/components/container.min.css'

@Component
export default class JavelinLanding extends Vue {
  imgs = Images
  showShip = false
  toggleImage () {
    this.showShip = !this.showShip
  }
}
